<template>
    <tr>
        <td class="cell_bottom cell_right">
            <div v-html="goal.best_practice.text">
            </div>
        </td>
        <td class="cell_bottom ap-select-column">
            <button 
                v-show="selectable"
                class="btn btn-orange-blue float-right text-white selectGoal"
                @click="selectGoal"
            >
                Select Goal
            </button>
            <span v-show="!saving"><strong>{{msgText}}</strong></span>
            <span v-show="saving">saving...</span>
        </td>
    </tr>
</template>

<script>
    export default {
        components: {},
        props: [
            'goal',
            'actionPlans',
        ],
        data() {
            return {
                saving: false
            }
        },
        watch: {
            actionPlans: {
                handler(newVal, oldVal) {
                    if (this.actionPlans.filter(ap => ap.goal_id == this.goal.id).length > 0) {
                        this.saving = false;
                    }
                }, 
                deep: true
            }
        },
        computed: {
            selected: function () {
                return this.inActionPlans
            },
            inActionPlans: function () {
                return this.actionPlans.map(ap => ap.goal_id).indexOf(this.goal.id) > -1
            },
            plan: function () {
                let plan = this.actionPlans.find(ap => ap.goal_id == this.goal.id);
                return (plan) ? plan : null;
            },
            inProgress: function () {
                return this.inActionPlans 
                        && this.plan.date_started !== null 
                        && this.plan.date_completed === null
            },
            isComplete: function () {
                return this.actionPlans 
                        && this.plan 
                        && this.plan.date_completed;
            },
            selectable: function () {
                return !this.selected 
                        && !this.saving 
                        && !this.inProgress 
                        && !this.isComplete
            },
            msgText: function () {
                if (this.isComplete) {
                    return 'Complete'
                }
                if (this.inProgress) {
                    return 'In progress'
                }
                if (this.selected) {
                    return 'Selected'
                }
            }
        },
        methods: {
            selectGoal() {
                this.saving = true;
                this.$emit('goalSelected', this.goal);
            }
        }
    }
</script>